import Button from "~/shared/Btn";
import React from "react";

type ChoiceActionsProps = {
    canOpen: boolean;
    canCancel: boolean;
    isAfterJobDate: boolean;
    markToReschedule: () => void;
    markToCancel: () => void;
};

export const ChoiceActions = ({ canOpen, canCancel, markToReschedule, markToCancel, isAfterJobDate }: ChoiceActionsProps) => {
    return (
        <div className="d-flex flex-column justify-content-end" style={{ height: "100%"}}>
            {canOpen && !isAfterJobDate ? (
                <div className="mb-2">
                    <Button block onClick={markToReschedule}>Reagendar sessão</Button>
                </div>
            ) : (
                ""
            )}

            {canCancel && !isAfterJobDate ? (
                <Button block variant="secondary" onClick={markToCancel}>Cancelar</Button>
            ): (
                ""
            )}
        </div>
    );
};
